import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { BaseService } from 'src/modules/base/shared/services/base.service';

export class Message {
  constructor(public author: string, public content: string) { }
}

@Injectable({
  providedIn: 'root'
})
export class ChatbotService {

  constructor(
    private baseService: BaseService
  ) { }

  conversation = new Subject<Message[]>();

  getChatBotAnswer(message: string, application_id: string, application_key: string) {
    const userMessage = new Message("user", message);
    this.conversation.next([userMessage]);
    var data = {
      application_id: application_id,
      application_key: application_key,
      question: message
    }
    // const botMessage = new Message("bot", message + " Bot response");
    //       setTimeout(() => {
    //         this.conversation.next([botMessage]);
    //       }, 1500);
    this.baseService.action(data, "BOT_RESPONSE", "chatbot", "bot_response").subscribe(
      (data: any) => {
        if (data.errCode == 0) {
          console.log("data: -->", data);
          const botMessage = new Message("bot", data.resource[0].answer);
          setTimeout(() => {
            this.conversation.next([botMessage]);
          }, 1500);
        }
      }, error => {
        const botMessage = new Message("bot", "We are offline, please connect me after sometime.");
        setTimeout(() => {
          this.conversation.next([botMessage]);
        }, 1500);
        console.log(error);
      }
    )
  }

}


